import Apollo from '@/graphql/vue-apollo'

import { Consts } from '@/helpers/consts'

import gql from 'graphql-tag'

const UPDATE_LOCAL_USER = gql`
  mutation UpdateLocalUser($user: User!) {
    updateLocalUser(user: $user) @client
  }
`
const CREATE_MISSION = gql`
  mutation CreateMission($input: CreateMissionInput!) {
    createMission(input: $input) {
      mission {
        id
        name
        type
        countries {
          id
          countryCode
          name
        }
        locations {
          id
        }
      }
    }
  }
`
const UPDATE_MISSION = gql`
  mutation UpdateMission($input: UpdateMissionInput!) {
    updateMission(input: $input) {
      mission {
        id
        endDate
        locations {
          id
        }
        name
        startDate
        publicationStartDate
        publicationEndDate
        type
        countries {
          id
          countryCode
          name
        }
      }
    }
  }
`

export default {
  createMission: async function (name, type, countries, publicationStartDate = null, publicationEndDate = null) {
    const input = { name, type, countries }

    // Une mission en continu naît avec ses dates de publication: son lieu technique en dépend
    // pour ne jamais avoir de dates par défaut (voir createMission côté API). Le formulaire les
    // valide avant l'appel, pour les autres types elles restent posées par updateMission ensuite.
    if (type === Consts.MISSION_TYPE_CONTINUOUS) {
      input.publicationStartDate = publicationStartDate
      input.publicationEndDate = publicationEndDate
    }

    const response = await Apollo.instance.defaultClient.mutate({
      mutation: CREATE_MISSION,
      variables: {
        input
      }
    })

    return response.data.createMission.mission
  },
  updateMission: async function (missionId, updatedValues) {
    const input = { missionId, ...updatedValues }

    // L'API attend companies (entreprise, dates de forfait, banque de candidatures) sur chaque
    // lieu à la place de companyIds: la conversion se fait ici pour ne pas dupliquer la
    // connaissance de ce contrat GraphQL dans chaque appelant du service.
    if (input.locations && Array.isArray(input.locations.value)) {
      input.locations = {
        value: input.locations.value.map((location) => {
          const { companyIds, ...rest } = location

          return {
            ...rest,
            // Le formulaire garde key (stabilité du v-for) et persisted (verrou des forfaits déjà
            // enregistrés) sur chaque entreprise (multiple-mission-location.vue): l'API ne connaît
            // pas ces champs, ils sont retirés ici.
            companies: Array.isArray(location.companies)
              ? location.companies.map(({ key, persisted, ...company }) => company)
              : (companyIds || []).map((companyId) => ({
                  companyId: typeof companyId === 'string' ? companyId : companyId.id,
                  packageStartDate: null,
                  packageEndDate: null,
                  isApplicationBank: false
                }))
          }
        })
      }
    }

    await Apollo.instance.defaultClient.mutate({
      mutation: UPDATE_MISSION,
      variables: {
        input
      }
    })
  },
  updateMissionSelected: async function (selectedMission) {
    const user = { selectedMission }
    await Apollo.instance.defaultClient.mutate({
      mutation: UPDATE_LOCAL_USER,
      variables: {
        user
      }
    })

    localStorage.setItem(Consts.LOCAL_STORAGE_CURRENT_MISSION, selectedMission)
  }
}
